import { useMemo } from 'react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { Button, Checkbox, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from "../../../../contexts";
import { getNextStepButtonText } from "../../ClientOnboardingV2.utils";
import desktopStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerDesktop.module.scss";
import mobileStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerMobile.module.scss";
import styles from "./Footer.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const collapseVariants = {
  hidden: {
    height: 0,
    opacity: 0,
    marginBottom: 0
  },
  visible: {
    height: 'auto',
    opacity: 1,
    marginBottom: 12
  }
};
const collapseTransition = {
  duration: 0.3,
  ease: 'easeInOut'
};
export const GetFooterTID = parentTestId => getTestIds({
  parentTestId
});
export const Footer = _ref => {
  let {
    currentStep,
    relationship,
    onNext,
    testId,
    isNextDisabled,
    hideNextButton,
    statement,
    isStatementAccepted,
    onStatementChange
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    FooterTestIds
  } = useMemo(() => GetFooterTID(testId), [testId]);
  const nextStepButtonText = getNextStepButtonText(currentStep, relationship);
  const containerStyles = isMobile ? mobileStyles : desktopStyles;
  const showCheckbox = statement && onStatementChange;
  if (hideNextButton) {
    return /*#__PURE__*/_jsx("div", {
      className: isMobile ? styles.mobileFooterSpacer : styles.footerSpacer
    });
  }
  if (isMobile) {
    return /*#__PURE__*/_jsxs(motion.div, {
      className: styles.mobileFooter,
      "data-testid": FooterTestIds.Root(),
      layout: true,
      transition: collapseTransition,
      children: [/*#__PURE__*/_jsx(AnimatePresence, {
        initial: false,
        children: showCheckbox && /*#__PURE__*/_jsx(motion.div, {
          variants: collapseVariants,
          initial: "hidden",
          animate: "visible",
          exit: "hidden",
          transition: collapseTransition,
          style: {
            overflow: 'hidden'
          },
          children: /*#__PURE__*/_jsx(Checkbox, {
            className: styles.statementCheckbox,
            onChange: e => onStatementChange(e.target.checked),
            testId: FooterTestIds.StatementCheckbox(),
            checked: isStatementAccepted,
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph1",
              weight: "light",
              children: statement
            })
          })
        }, "checkbox-collapse")
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onNext,
        className: containerStyles.button,
        testId: FooterTestIds.NextButton(),
        disabled: isNextDisabled,
        children: nextStepButtonText
      })]
    });
  }
  return /*#__PURE__*/_jsx(Row, {
    className: showCheckbox ? styles.footerWithCheckbox : containerStyles.footer,
    testId: FooterTestIds.Root(),
    children: /*#__PURE__*/_jsxs(Row, {
      className: cn(styles.footerContent, {
        [styles.footerContentWithCheckbox]: showCheckbox
      }),
      testId: FooterTestIds.FooterContent(),
      children: [showCheckbox && /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Checkbox, {
          className: styles.statementCheckbox,
          onChange: e => onStatementChange(e.target.checked),
          testId: FooterTestIds.StatementCheckbox(),
          checked: isStatementAccepted,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            weight: "light",
            children: statement
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onNext,
        className: desktopStyles.button,
        testId: FooterTestIds.NextButton(),
        disabled: isNextDisabled,
        children: nextStepButtonText
      })]
    })
  });
};